module.exports = __webpack_public_path__ + "static/media/161.0f1e9906.jpg";